import React from "react";

import * as S from "./styled";

const BrandLinks = () => (
  <S.BrandLinks>
    <S.BrandLink>
      <S.BrandLinkText href="https://www.zillow.com/">Zillow</S.BrandLinkText>
    </S.BrandLink>
    <S.BrandLink>
      <S.BrandLinkText href="https://www.trulia.com/">Trulia</S.BrandLinkText>
    </S.BrandLink>
    <S.BrandLink>
      <S.BrandLinkText href="https://hotpads.com/">Hotpads</S.BrandLinkText>
    </S.BrandLink>
    <S.BrandLink>
      <S.BrandLinkText href="https://outeast.com">Out East</S.BrandLinkText>
    </S.BrandLink>
  </S.BrandLinks>
);

export default BrandLinks;
